import {
  Component,
  Inject,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  Dialog,
  DialogFormFields,
} from 'src/app/shared/models/app-models/Dialog.model';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, take, Subject, takeUntil, lastValueFrom } from 'rxjs';
import { Vendor } from 'src/app/shared/models/database-models/SaveMyPurchase.model';
import { Store } from '@ngrx/store';
import {
  ExtendedMaterialGroup,
  ExtendedMaterialSubGroup,
  ExtendedOEM,
  StoreDropdowns,
} from '../../models/app-models';
import VendorStatusJSON from 'src/app/data/constants/VendorStatus.json';
import VendorTypeJSON from 'src/app/data/constants/VendorTypes.json';
import { BackendApiService } from 'src/app/core/services/backend-api';
import VendorTypes from 'src/app/data/constants/VendorTypes.json';
import { Country } from 'src/app/shared/models/database-models/Country.model';
import _ from 'lodash';
@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent implements OnInit {
  @Input() formFields!: DialogFormFields[];
  @Input() tblColumns: string[] = [];
  @Input() tblData: string[] = [];
  dynamicForm: FormGroup;
  dataSource!: MatTableDataSource<any>;
  displayedCols: string[] = [];
  expandedElement!: Vendor | null;
  destroy$: Subject<boolean> = new Subject<boolean>();
  isAutoSet: boolean = false;

  // dropdowns
  countryDp: any[] = [];
  vendorStatusDp: any[] = VendorStatusJSON.filter((status) => status.isActive);
  vendorTypeDp: any[] = VendorTypeJSON.filter((status) => status.isActive);
  materialGroupDp: ExtendedMaterialGroup[] = [];
  materialSubGroupDp: ExtendedMaterialSubGroup[] = [];
  originalMaterialSubGroupDp: ExtendedMaterialSubGroup[] = [];
  brandDp: ExtendedOEM[] = [];

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public input: Dialog,
    private fb: FormBuilder,
    private BackendApi: BackendApiService,
    private store: Store<{ dp: StoreDropdowns }>
  ) {
    const controlConfigs = this.createControlConfigs();
    this.dynamicForm = this.fb.group(controlConfigs);
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === 'Escape') {
        input.click();
      }
    });
  }

  async ngOnInit(): Promise<void> {
    if (this.input.isForm) {
      this.store
        .select('dp')
        .pipe(takeUntil(this.destroy$))
        .subscribe((dp: StoreDropdowns) => {
          this.materialGroupDp = dp.MaterialGroup as ExtendedMaterialGroup[];
          this.materialSubGroupDp =
            dp.MaterialSubGroup as ExtendedMaterialSubGroup[];
          this.originalMaterialSubGroupDp =
            dp.MaterialSubGroup as ExtendedMaterialSubGroup[];
          this.brandDp = dp.OEM as ExtendedOEM[];
        });

      this.BackendApi.getCountries()
        .pipe(take(1))
        .subscribe((data: any) => {
          const options = _.sortBy(data.map((option: any) => ({ id: option.Code, value: option.Name })), ['value']) 
          this.countryDp = options;
        });
    }
  }

  toggleExpansion(row: any): void {
    row.expanded = !row.expanded;
    // this 'refreshes' the table data
    this.dataSource.data = [...this.dataSource.data];
  }

  toggleRow(element: Vendor): void {
    this.expandedElement = this.expandedElement === element ? null : element;
  }

  private createControlConfigs() {
    const ctConfigs: { [key: string]: any } = {};
    this.input.formFields?.forEach((field) => {
      // get input value from search input
      if (field.controlName === 'charSearch') {
        ctConfigs[field.controlName] = [
          this.input.vendorInput,
          field.validators,
        ];
      } else {
        ctConfigs[field.controlName] = ['', field.validators];
      }
    });
    return ctConfigs;
  }

  close(): void {
    this.dialogRef.close();
  }

  onMaterialGroupChange(event: ExtendedMaterialGroup) {
    this.input.formControl.controls['materialGroup'].setValue(null);
    if (event) {
      this.materialSubGroupDp = this.originalMaterialSubGroupDp.filter(
        (subgroup) => subgroup.ParentGroupCode == event.Code
      );
    }
  }
}
